import React from "react";

interface DetailPageLayoutProps {
    children?: React.ReactNode;
}

export const DetailPageLayout: React.FC<DetailPageLayoutProps> = props => {
    const { children } = props;
    return (
        <div className="px-4 pb-2 mb-2 bg-zinc-50 min-h-screen border-t border-t-gray-200">
            {children}
        </div>
    );
};
